module.exports = __webpack_public_path__ + "static/media/icon_update_white.cef00a38.svg";